import { Download, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { downloadUrl, previewUrl } from "@/lib/api";

export function PdfPreviewDialog({ doc, open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="pdf-preview-dialog" className="flex h-[88vh] max-w-5xl flex-col gap-4 rounded-3xl p-4 sm:p-6">
        <DialogHeader className="flex-row items-center justify-between gap-4 space-y-0 pr-8">
          <div className="min-w-0">
            <DialogTitle className="truncate font-display text-xl font-bold text-ph-ink">{doc.title}</DialogTitle>
            <DialogDescription className="font-mono-ph text-xs uppercase tracking-wider">{doc.brand_name} · PDF preview</DialogDescription>
          </div>
          <div className="flex shrink-0 items-center gap-2">
          <a href={previewUrl(doc.id)} target="_blank" rel="noopener noreferrer" data-testid="pdf-preview-open-tab" aria-label="Open in a new tab"
            className="inline-flex items-center gap-2 rounded-full border border-ph-line px-3 py-2 text-sm font-medium text-ph-ink hover:bg-ph-raised">
            <ExternalLink className="h-4 w-4" /> <span className="hidden sm:inline">Open</span>
          </a>
          <a
            href={downloadUrl(doc.id, "pdf")}
            download
            data-testid="pdf-preview-download-btn"
            onClick={() => toast.success("PDF download started", { description: doc.title })}
            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-ph-lime px-4 py-2 text-sm font-semibold text-ph-navy hover:shadow-[0_0_24px_rgba(182,255,92,0.45)]"
          >
            <Download className="h-4 w-4" /> Download
          </a>
          </div>
        </DialogHeader>
        {open && (
          <iframe title={`${doc.title} preview`} src={previewUrl(doc.id)} className="h-full w-full flex-1 rounded-2xl border border-ph-line bg-ph-raised" />
        )}
      </DialogContent>
    </Dialog>
  );
}
